<template>
  <div class="text-container">
    <div style="text-align: center; margin-top: 100px; font-size: 20px; color: #909399;">
    暂未开放
  </div>
    <!-- 
    <div class="header">
      <span class="title">选择策略</span>
      <el-select v-model="strategy" style="width: 160px">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </div>
    <div class="main">
      <div class="main-up">
        <div class="main-up-content">
          <el-icon :size="100"><Document /></el-icon>

          <p v-if="!percentage">
            点击下方【本地上传】后，点击【生成】依据策略生成U盘可用文件
          </p>
          <div
            style="display: flex; flex-direction: column; align-items: center"
            v-else
          >
            <div
              style="display: flex; flex-direction: column; align-items: center"
              v-if="!auditResult"
            >
              <el-progress
                style="width: 400px"
                :status="status"
                :text-inside="true"
                :stroke-width="16"
                :percentage="percentage"
              >
              </el-progress>
              <div>
                {{ uploadMap[status] || "上传中" }}
              </div>
            </div>

            <div
              style="display: flex; flex-direction: column; align-items: center"
              v-if="auditResult"
            >
              <div style="margin-bottom: 10px">
                {{ auditMessage }}
              </div>

              <div v-if="loadable" class="text-download">
                <div class="container" @click="download">
                  <img style="height: 50px" :src="downloadImg" alt="download" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="main-down">
        <div class="main-down-action">
          <el-input
            size="large"
            value=""
            style="margin-right: 10px; border: 4px solid #fff"
          >
            <template #append>
              <el-upload
                :show-file-list="false"
                action="#"
                :auto-upload="true"
                :http-request="customUpload"
                :before-upload="beforeUpload"
                accept=".txt,.doc,.docx"
              >
                <template #trigger>
                  <el-button type="info">本地上传</el-button>
                </template>
              </el-upload>
            </template>
          </el-input>
          <el-button
            size="large"
            color="#1547ec"
            :disabled="status !== 'success'"
            type="primary"
            @click="generate"
            >无感水印</el-button
          >
        </div>
        <div class="main-down-text">支持 WORD、TXT 格式，小于2MB</div>
      </div>
    </div>
  -->
  </div>
</template>
<script setup lang="ts">
import { ref, computed, watch } from "vue";
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";
import { uploadText, generateText, downloadFile } from "../../api/index";
import downloadImg from "../../assets/downloadImg.png";
import { AuditResultMap, uploadMap } from "../../enum";

const strategy = ref("1");
const options = [
  {
    value: "1",
    label: "默认策略",
  },
];

const beforeUpload = (file: File) => {
  const limitSize = 2 * 1024 * 1024;
  if (file.size > limitSize) {
    ElMessage({
      message: "上传文件大小不能超过 2MB",
      type: "error",
    });
    return false;
  }
  return true;
};

const backupFile = ref<File>({} as File);
const generateFilePath = ref("");
const percentage = ref(0);
const status = ref("");
// 进度条增长
const timer = ref(0);
function increase() {
  timer.value = setInterval(() => {
    percentage.value += 10;
  }, 1000);
}
watch(
  () => percentage.value,
  (percen) => {
    if (percen >= 90 && timer.value) clearInterval(timer.value);
  }
);

const loadable = computed(() => auditResult.value === "2");
const auditResult = ref("");
const auditMessage = ref("");

const customUpload = async (file: { file: File }) => {
  backupFile.value = file.file;
  percentage.value = 0;
  status.value = "";
  auditResult.value = "";
  auditMessage.value = "";

  increase();

  const { code, message } = await uploadText(file.file);

  if (code === "success") {
    percentage.value = 100;
    status.value = "success";
  } else {
    clearInterval(timer.value);
    status.value = "exception";
  }
  ElNotification({
    title: message,
    type: code === "success" ? "success" : "error",
  });
};

const generate = async () => {
  const { code, content, message } = await generateText(backupFile.value.name);
  auditResult.value = content?.status_code || "0";
  auditMessage.value = message || AuditResultMap[auditResult.value];

  if (auditResult.value === "1") {
    ElMessageBox.alert("无感水印中", "提示", {
      showConfirmButton: false,
    });
  }
  generateFilePath.value = (content as { path: string }).path || "";
  ElNotification({
    title: message,
    type: code === "success" ? "success" : "error",
  });
};

// 下载
const download = async () => {
  try {
    const res = await downloadFile(generateFilePath.value);
    if (res?.code === "error") throw new Error(res.message);
    const blob = new Blob([res.content as string], {
      type: (res.content as { type: string }).type,
    }); // 创建Blob对象
    const url = URL.createObjectURL(blob); // 创建Blob URL
    const a = document.createElement("a"); // 创建<a>元素
    a.href = url;
    a.download = generateFilePath.value; // 设置下载文件名
    document.body.appendChild(a); // 添加<a>到文档
    a.click(); // 模拟点击<a>元素
    URL.revokeObjectURL(url); // 清理Blob URL
    document.body.removeChild(a); // 移除<a>元素
  } catch (error) {
    console.error("下载失败", error);
  }
};
</script>
<style lang="scss" scoped>
.text-container {
  .header {
    display: flex;
    align-items: center;
    .title {
      margin-right: 16px;
    }
  }
  .main {
    background-color: #4f4f4f;
    height: 400px;
    margin: 50px 50px 20px;
    border-radius: 4px;
    &-up {
      color: #dad5d5;
      height: 320px;
      display: flex;
      align-items: center;
      justify-content: center;
      &-content {
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
    &-down {
      padding: 4px 20px;
      height: 80px;
      background-color: #000000;
      &-action {
        display: flex;
        align-items: center;
      }
      &-text {
        color: #fff;
        margin-top: 4px;
      }
    }
  }
  .text-download {
    .container {
      cursor: pointer;
      display: inline-block;
      border: 2px solid #4f4f4f;
    }
  }
}

::v-deep .el-input__wrapper {
  padding: 0;
  background-color: #4f4f4f;
}
::v-deep .el-input-group__append,
.el-input-group__prepend {
  background-color: #9a9a9a;
  color: #fff;
}
</style>
